export default __webpack_public_path__ + "static/media/2.ce0328b2.png";